<section class="lp-countries-brands-grid">
  <div class="row">
    <div class="col-12">
      <div class="lp-countries-brands-grid-header">
        <h2 class="brands-grid-title">
          {{ title }}
        </h2>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="lp-countries-brands-grid-wrapper">
        <div *ngFor="let brand of brands">
          <div class="lp-countries-brands-grid-brand-logo" [ngClass]="{'lp-countries-brands-grid-brand-logo-gap': brand?.brandName === 'Gap', 'lp-countries-brands-grid-brand-logo-ipsy': brand?.brandName === 'Ipsy','lp-countries-brands-grid-brand-logo-anua': brand?.brandName === 'Anua', 'lp-countries-brands-grid-brand-logo-boligretning': brand?.brandName === 'Boligretning', 'lp-countries-brands-grid-brand-logo-jysk': brand?.brandName === 'JYSK','lp-countries-brands-grid-brand-logo-jemfix': brand?.brandName === 'JemogFix', 'lp-countries-brands-grid-brand-logo-bilka': brand?.brandName === 'Bilka','lp-countries-brands-grid-brand-logo-2dehands': brand?.brandName === '2Dehands', 'lp-countries-brands-grid-brand-logo-veritas': brand?.brandName === 'Veritas', 'lp-countries-brands-grid-brand-logo-swisssense': brand?.brandName === 'SwissSense', 'lp-countries-brands-grid-brand-logo-liverpool-mexico': brand?.brandName == 'Liverpool-Mexico', 'lp-countries-brands-grid-brand-logo-sanborns' : brand?.brandName === 'Sanborns','lp-countries-brands-grid-brand-logo-sears': brand?.brandName === 'Sears'}">
            <img src="{{ brand?.brandLogo }}" alt="{{brand?.brandName}} logo" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="lp-countries-brands-grid-cta">
        <button class="lp-countries-brands-grid-cta-btn" [routerLink]="['/','signup']" aria-label="Try for Free">
          <span>+</span> Try for Free
        </button>
      </div>
    </div>
  </div>
</section>